import { FinancialDocument } from "@common/types/financialDocument";
import { Button } from "@design-system/Button/Button";
import { useCallback } from "react";

interface Props {
    attachedDocumentIds: number[];
    attachDocument: (documentId: number) => void;
    financialDocument: FinancialDocument;
}

export const DocumentCta: React.FC<Props> = ({
    attachedDocumentIds,
    attachDocument,
    financialDocument,
}) => {
    const alreadyAttached = attachedDocumentIds.some(
        (id) => id === financialDocument.id,
    );

    const handleAttach = useCallback(() => {
        attachDocument(financialDocument.id);
    }, [financialDocument.id, attachDocument]);

    return (
        <Button
            variant="primary"
            size="sm"
            onClick={handleAttach}
            disabled={alreadyAttached}
        >
            {alreadyAttached ? "Added" : "Add"}
        </Button>
    );
};
